import React from 'react';

export const OrderSummary = ({
  details, setField, subtotal, taxRate, customerTaxExempt,
  taxableSubtotal, tax, freight, total, loading, cart, handleSubmit, handleSaveDraft, onCancel
}) => (
  <div className="bg-card p-6 rounded-lg border border-border">
    <div className="flex items-center justify-between mb-4">
      <h3 className="text-lg font-semibold">Order Summary</h3>
      <select value={details.status} onChange={setField('status')}
        className="px-3 py-1.5 border border-input rounded-md text-sm bg-background font-medium" data-testid="summary-status-select">
        <option value="draft">Draft</option>
        <option value="pending">Pending</option>
        <option value="confirmed">Confirmed</option>
        <option value="completed">Completed</option>
      </select>
    </div>
    <div className="space-y-2">
      <div className="flex justify-between">
        <span className="text-muted-foreground">Subtotal</span>
        <span className="font-medium tabular-nums">${subtotal.toFixed(2)}</span>
      </div>
      <div className="flex justify-between">
        <span className="text-muted-foreground">
          {details.tax1_name || 'Tax'} {customerTaxExempt ? '(Exempt)' : `(${taxRate}%)`}
        </span>
        <span className={`font-medium tabular-nums ${customerTaxExempt ? 'text-green-600' : ''}`}>
          {customerTaxExempt ? '$0.00' : `$${tax.toFixed(2)}`}
        </span>
      </div>
      {!customerTaxExempt && taxableSubtotal < subtotal && (
        <p className="text-xs text-muted-foreground text-right">Tax on ${taxableSubtotal.toFixed(2)} of ${subtotal.toFixed(2)}</p>
      )}
      {freight > 0 && (
        <div className="flex justify-between">
          <span className="text-muted-foreground">Freight</span>
          <span className="font-medium tabular-nums">${freight.toFixed(2)}</span>
        </div>
      )}
      <div className="pt-2 border-t border-border flex justify-between">
        <span className="font-semibold">Total</span>
        <span className="text-2xl font-semibold tabular-nums">${total.toFixed(2)}</span>
      </div>
    </div>
    <div className="mt-6 flex gap-3">
      <button onClick={onCancel}
        className="px-4 py-3 border border-red-300 text-red-600 rounded-md hover:bg-red-50 font-medium"
        data-testid="cancel-order-btn">
        Cancel
      </button>
      <button onClick={handleSaveDraft} disabled={loading || cart.length === 0}
        className="flex-1 px-4 py-3 border border-input rounded-md hover:bg-muted disabled:opacity-50 disabled:cursor-not-allowed font-medium"
        data-testid="save-draft-order-btn">
        {loading ? 'Saving...' : 'Save as Draft'}
      </button>
      <button onClick={handleSubmit} disabled={loading || cart.length === 0}
        className="flex-1 px-4 py-3 bg-primary text-white rounded-md hover:bg-primary/90 disabled:opacity-50 disabled:cursor-not-allowed font-medium"
        data-testid="create-order-btn">
        {loading ? 'Creating...' : 'Create Order'}
      </button>
    </div>
  </div>
);
